import { Component, Input } from '@angular/core';
import { PopUpController } from 'src/app/shared/components/pop-up/services/pop-up-controller.service';
import { LegalPoliciesComponent } from '../legal-policies/legal-policies.component';
import { TermsOfServiceComponent } from '../terms-of-service/terms-of-service.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  /**
   * footer height
   */
  @Input() height = '100px';

  /**
   *
   * @param popUpController service to manage pop-up
   */
  constructor(private popUpController: PopUpController) {}

  /**Shows terms of service */
  showTermsOfService() {
    this.popUpController.openPopUp({
      component: TermsOfServiceComponent,
      componentProps: {
        showCheckbox: false,
      },
      styles: {
        maxWidth: '500px',
        maxHeight: '500px',
      },
    });
  }
  /**Shows legal policies*/
  showLegalPolicies() {
    this.popUpController.openPopUp({
      component: LegalPoliciesComponent,
      styles: {
        maxWidth: '500px',
        maxHeight: '500px',
      },
    });
  }
}
